import React from "react"
import moment from "moment"

export default ({ value, format = "Do MMMM YYYY", localTooltipSameFormat = false }) => {
  try {
    const date = moment(value)

    const getLocalTooltipFormat = () => (localTooltipSameFormat ? format : undefined)

    return (
      <span className="format-date" title={moment(date).local().format(getLocalTooltipFormat())}>
        {value && date.format(format)}
      </span>
    )
  } catch (ex) {
    return <span>Data invalid.</span>
  }
}
